import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Routes from '../common/Routes'

const LoggedOutRedirector = (props) => {
  return (
    <>
      <Route exact path={Routes.profiles.edit}>
        <Redirect to={`/login?redirect_uri=${encodeURIComponent(window.location.href)}`} />
      </Route>
    </>
  )
}

export default LoggedOutRedirector
